import { render, staticRenderFns } from "./IqcReturnList.vue?vue&type=template&id=ff0969b4"
import script from "./IqcReturnList.vue?vue&type=script&lang=js"
export * from "./IqcReturnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports